import {
  GetAiVoicesApi,
  GetAiLanguagesApi,
  TextToAudioApi,
  TextToDialogueApi,
} from "@/database/constants/api";
import type {
  TextToAudioParams,
  TextToDialogueParams,
} from "@/database/constants/model";
import {
  CreditListApi,
  deleteCategoryApi,
  DeletePresetApi,
  DenmarkPublishPayload,
  DiscoverListMediasApi,
  DownloadCheckApi,
  FacebookPublishPayload,
  generateClipApi,
  getCategoryListApi,
  GetCurrentChapterApi,
  GetCurrentPresetDetailsApi,
  GetPresetListApi,
  GetSubtitleListApi,
  HomeListApi,
  HomeListParams,
  LinkedInPublishPayload,
  LiveListApi,
  GetRecommendedArticlesApi,
  PresetModel,
  SearchListMediasApi,
  SocialEmbedsAgg,
  SubtitleModel,
  trimMediaApi,
  TrimMediaParams,
  updateCategoryApi,
  UpdatePresetApi,
  UpdateSubtitleApi,
  WiredDiscoverListMediasApi,
  YoutubePublishPayload,
  PresetListModel,
  DeleteDenmarkPublishApi,
  AllAdminPresets,
  GetAdminCurrentPresetDetailsApi,
  fetchDenmarkTaxonomyListApi,
  fetchDenmarkTaxonomyByCodeApi,
  DenmarkTaxonomyCodeFetchParams,
  fetchDenmarkSectionListApi,
  fetchDenmarkEntityGetApi,
  fetchPriorityListApi,
  updatePriorityListApi,
  FetchPriorityListParams,
  UpdatePriorityListReq,
  SectionEntity,
  GetArticleInfoListApi,
  GetFavoriteDenmarkSectionListApi,
  MarkFavoriteApi,
  RemoveFavoriteApi,
  articleInfoParams,
  GetAddedInListApi,
  GetKeywordsApi,
  GetCategoryTagsApi,
  fetchLivePreviewApi,
  fetchLiveUrlApi,
} from "@/database";
import {
  addChapter,
  deleteChapter,
  setIsPublishingMedia,
  setMediaList,
  setParentMediaList,
  setSecondaryMediaList,
  setMediaDetails,
  updateChapter,
  setHostList,
  setMediaChapters,
  setCurrentOpenedChapter,
  setHostSubsection,
  setMediaAssets,
  setCreditList,
  setPreMediaList,
  setPostMediaList,
  setisFilter,
  setHomeList,
  setIsThumbnailUploading,
  setCurrentImageId,
  setCurrentImage,
  setLiveList,
  setIsClearFilter,
  setImageCreditList,
  setVideoCreditList,
  setAudioCreditList,
  setActiveCustomUploadTab,
  setPresetList,
  setChunkInfo,
  setSubtitleList,
  setCategoryList,
  setPresetMediaList,
  setPreviousFilters,
  setPreviewMediaDetails,
  setCurrentPresetDetails,
  updateSocialInMediaDetails,
  setAdminPresetList,
  setAdminCurrentPresetDetails,
  setAdminBucketList,
  setDenmarkTaxonomyList,
  setDenmarkTaxonomyCodeFetch,
  setDenmarkSectionList,
  setDenmarkEntityList,
  setPriorityList,
  syncSavedSectionPriorityList,
  setArticleInfoList,
  setArticleSearchList,
  setFavoriteDenmarkSectionList,
  setGlobalFavSectionList,
  setAddedInList,
  removePendingSocialUpdate,
  setKeywordList,
  setCategoryTagsResult,
  setLivePreview,
  setLiveUrl,
  setAiVoices,
  setAiLanguages,
  setAiTextToAudio,
  setAiTextToDialogue,
  updateMediaInMediaList,
} from "./media.slice";
import {
  setBunchCategoryList,
  setBunchLanguageList,
} from "../constants/constants.slice";
import { RootState } from "..";
import { Dispatch } from "redux";
import {
  ListMediasApi,
  GetMediaApi,
  GetTokenForDownloadApi,
  DeleteMediaApi,
  ReuploadMediaApi,
  UrlUploadMediaThumbnailApi,
  UrlUploadMediaThumbnailParams,
  UpdateMediaApi,
  GetAddChapterApi,
  GetDeleteChapterApi,
  GetListChaptersApi,
  GetUpdateChapterApi,
  MediaSecurityFormData,
  MediaFormData,
  MediaModel,
  ArticleSearchParams,
  fetchHostsApi,
  fetchHostSubSectionAPI,
  fetchArticlesApi,
  articleSearchApi,
  updatePublishMediaApi,
  updateVideoPublishMediaApi,
  getVodDetailsApi,
  callPublishMediaApi,
  AssetsAPI,
  GetChunkInfoApi,
  AddPresetApi,
  createCategoryApi,
  GetAdminPresetListApi,
  GetUserBucketListApi,
} from "@/database";
import {
  CreditParams,
  MediaListParams,
  GetRecommendedArticlesParams,
  AdminPresetListState,
} from "./media.models";
import { Display_Value_Key as dvk } from "@/components/Create/utils";
import { toast } from "../../components";
import {
  setCategories,
  setCategory,
  setLanguage,
  setTag,
  setCast,
  setGenre,
  setIsRootLoading,
} from "../app/app.slice";

export const removeDuplicateKeys = (
  inputObj: Record<string, any>
): Record<string, any> => {
  return Object.keys(inputObj).reduce(
    (acc, key) => {
      if (!key.endsWith(dvk)) {
        acc[key] = inputObj[key];
      }
      return acc;
    },
    {} as Record<string, any>
  );
};

export const getListMedia =
  (params: MediaListParams) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    params = removeDuplicateKeys(params);

    if (params.key !== "secondary") {
      dispatch(setMediaList({ isLoading: true }));
    }
    const response = await ListMediasApi({
      ...params,
      foreign_keys: [
        "socials",
        "ctbydata",
        "mtbydata",
        "youtubedata",
        "agencydata",
        "teamdata",
      ],
    });

    if (params.key === "pre") {
      dispatch(
        setPreMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "post") {
      dispatch(
        setPostMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    }
    // else if (params.key === 'preset') {
    //   dispatch(
    //     setPresetMediaList({
    //       data: { list: response.data, count: response.count },
    //       error: response.error,
    //       isLoading: false,
    //     }),
    //   );
    // }
    else if (params.key === "secondary") {
      dispatch(
        setSecondaryMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    }
    return response;
  };

export const getDiscoverListMedia =
  (params: MediaListParams) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    params = removeDuplicateKeys(params);

    dispatch(setMediaList({ isLoading: true }));
    const response = await DiscoverListMediasApi({
      ...params,
      foreign_keys: ["socials", "ctbydata", "mtbydata", "youtubedata"],
    });

    if (params.key === "pre") {
      dispatch(
        setPreMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "post") {
      dispatch(
        setPostMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
      // } else if (params.key === 'preset') {
      //   dispatch(
      //     setPresetMediaList({
      //       data: { list: response.data, count: response.count },
      //       error: response.error,
      //       isLoading: false,
      //     }),
      //   );
      // }
    } else {
      dispatch(
        setMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    }
  };

export const getDiscoverWiredListMedia =
  (params: MediaListParams) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    params = removeDuplicateKeys(params);

    dispatch(setMediaList({ isLoading: true }));
    const response = await WiredDiscoverListMediasApi({
      ...params,
      foreign_keys: ["socials", "ctbydata", "mtbydata", "youtubedata"],
    });

    if (params.key === "pre") {
      dispatch(
        setPreMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "post") {
      dispatch(
        setPostMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    }
    // else if (params.key === 'preset') {
    //   dispatch(
    //     setPresetMediaList({
    //       data: { list: response.data, count: response.count },
    //       error: response.error,
    //       isLoading: false,
    //     }),
    //   );
    // }
    else {
      dispatch(
        setMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    }
  };

export const getLiveList =
  () => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await LiveListApi();

    dispatch(
      setLiveList({
        data: { list: response.data },
        error: response.error,
        isLoading: false,
      })
    );
  };

export const getRecommendedArticles =
  (params: GetRecommendedArticlesParams) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await GetRecommendedArticlesApi({ ...params });
    return response;
  };

export const getSearchedListMedia =
  (params: MediaListParams) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    params = removeDuplicateKeys(params);
    dispatch(setPostMediaList({ isLoading: true }));
    dispatch(setPreMediaList({ isLoading: true }));

    const includeForeignKeys = params?.is_foreign_keys !== false;
    delete params.is_foreign_keys;

    const response = await SearchListMediasApi({
      ...params,
      ...(includeForeignKeys && {
        foreign_keys: ["socials", "ctbydata", "mtbydata", "youtubedata"],
      }),
    });
    if (params.key === "pre") {
      dispatch(
        setPreMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "post") {
      dispatch(
        setPostMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "parentid") {
      dispatch(
        setParentMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "secondary") {
      dispatch(
        setSecondaryMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setMediaList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    }
    return response;
  };
export const getCreditList =
  (params: CreditParams) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setCreditList({ isLoading: true }));
    const response = await CreditListApi(params.name);

    if (params.key === "audio") {
      dispatch(
        setAudioCreditList({
          data: { list: response.data },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "video") {
      dispatch(
        setVideoCreditList({
          data: { list: response.data },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "image") {
      dispatch(
        setImageCreditList({
          data: { list: response.data },
          error: response.error,
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setCreditList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    }
  };

export const downloadCheck =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await DownloadCheckApi(params);
    return response;
  };

export const getTokenForDownload =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await GetTokenForDownloadApi(params);
    return response;
  };

export const getMedia =
  (params: Record<string, any> & { skipStoreUpdate?: boolean }) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    // skipStoreUpdate: fetch media without touching mediaDetails in the store -
    // used when a caller just needs fresh media data (e.g. jwt/fid for a
    // reupload) without resetting/re-rendering whatever is currently displayed.
    if (params.skipStoreUpdate) {
      return GetMediaApi({
        id: params.id,
        foreign_keys: ["socials", "ctbydata", "mtbydata", "youtubedata"],
      });
    }

    if (params.type === "preview") {
      dispatch(
        setPreviewMediaDetails({
          isLoading: true,
          data: { media: {} as MediaModel },
        })
      );
    } else {
      dispatch(
        setMediaDetails({ isLoading: true, data: { media: {} as MediaModel } })
      );
    }
    const response = await GetMediaApi({
      id: params.id,
      foreign_keys: ["socials", "ctbydata", "mtbydata", "youtubedata"],
    });

    if (params.type === "preview") {
      dispatch(
        setPreviewMediaDetails({
          isLoading: false,
          error: response.error,
          data: { media: response.data },
        })
      );
    } else {
      dispatch(
        setMediaDetails({
          isLoading: false,
          error: response.error,
          data: {
            media: response.data,
            consumePendingSocials: true,
          },
        })
      );
    }
    return response;
  };

export const getAssets =
  (params: Record<string, any>) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setMediaAssets({ isLoading: true }));
    const response = await AssetsAPI(params.pid);
    dispatch(
      setMediaAssets({
        isLoading: false,
        error: response.error,
        data: { assets: response.data },
      })
    );
  };

export const getChunkInfo =
  (params: { upload_id: string; token: string }) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setChunkInfo({ isLoading: true }));
    const response = await GetChunkInfoApi(params);
    if (response.status === 200) {
      dispatch(
        setChunkInfo({
          data: { uploadId: params.upload_id, list: response.data },
          error: response.error,
          isLoading: false,
        })
      );
    } else {
      dispatch(setChunkInfo({ error: response.error, isLoading: false }));
    }
    return response;
  };

export const deleteMedia =
  (params: Record<string, any>, method: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await DeleteMediaApi({
      id: params.id,
      method: method,
      socials: params.socials || [],
      reason: params.reason || "",
      notes: params.notes || "",
    });

    if (response.status === 200) {
      const mediaList = getState().media.mediaList;
      const list = mediaList.list;
      const updatedMediaList = list.filter((media) => media.id !== params.id);
      const updatedCount = mediaList.count;
      dispatch(
        setMediaList({
          data: {
            list: updatedMediaList,
            count: updatedCount - 1,
          },
        })
      );
      const actionText = method === "archive" ? "inactivated" : "deleted";
      toast.success(`Your content has been ${actionText}`);
    } else {
      const actionText = method === "archive" ? "inactivate" : "delete";
      toast.fail(`Failed to ${actionText} media`);
    }
  };

export const reuploadMedia =
  (params: {
    id: string;
    damid: string;
    team?: string;
    agency?: string;
    asset_type?: string;
    is_short?: number;
    fid?: string;
    title?: string;
  }) =>
  async (dispatch: Dispatch) => {
    const response = await ReuploadMediaApi(params);

    if (response.status === 200 && response.data) {
      dispatch(
        updateMediaInMediaList({
          media: { id: params.id, state: 0, status: 0 },
        })
      );
    } else {
      toast.fail(response.error || "Failed to reupload media");
    }

    return response;
  };

export const urlUploadMediaThumbnail =
  (params: UrlUploadMediaThumbnailParams) => async () => {
    const response = await UrlUploadMediaThumbnailApi(params);

    if (!(response.status === 200)) {
      toast.fail(response.error || "Failed to upload thumbnail");
    }

    return response;
  };

export const getAddPreset =
  (params: PresetListModel) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setPresetList({ isLoading: true }));

    params.size = 1000;
    const response = await AddPresetApi(params);

    if (response.status === 200) {
      // Get the current preset list from the store
      const currentList = getState().media.presetList.list || [];
      // Append the new preset to the existing list
      const newPreset = Array.isArray(response.data)
        ? response.data[0]
        : response.data;
      const updatedList = [...currentList, newPreset];

      dispatch(
        setPresetList({
          data: { list: updatedList },
          error: response.error,
          isLoading: false,
        })
      );
      return response;
    } else {
      toast.fail("");
      dispatch(
        setPresetList({
          data: { list: getState().media.presetList.list },
          error: response.error,
          isLoading: false,
        })
      );
      return response;
    }
  };

export const getAdminPresetList =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setAdminPresetList({ isLoading: true }));
    const response = await GetAdminPresetListApi(params);
    if (response.status === 200) {
      dispatch(
        setAdminPresetList({
          data: { list: response.data },
          error: response.error,
          isLoading: false,
        })
      );
    } else {
      toast.fail("Failed to fetch admin preset list");
      dispatch(
        setAdminPresetList({
          data: { list: {} as AllAdminPresets },
          error: response.error,
          isLoading: false,
        })
      );
      // return response;
    }
  };

export const getUserBucketList =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setAdminBucketList({ isLoading: true }));
    const response = await GetUserBucketListApi(params);
    if (response.status === 200) {
      dispatch(
        setAdminBucketList({
          data: { list: response.data.list },
          error: response.error,
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setAdminBucketList({
          data: { list: [] },
          error: response.error,
          isLoading: false,
        })
      );
    }
  };

export const getDenmarkTaxonomyList =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setDenmarkTaxonomyList({ isLoading: true, error: "" }));
    const response = await fetchDenmarkTaxonomyListApi(params);

    const realList: any[] =
      response.status === 200 ? (response.data ?? []) : [];

    dispatch(
      setDenmarkTaxonomyList({
        isLoading: false,
        data: { list: realList },
        error:
          response.status === 200
            ? ""
            : (response as any).error || "Failed to load taxonomy",
      })
    );
  };

export const getDenmarkTaxonomyByCode =
  (params: DenmarkTaxonomyCodeFetchParams) => async (dispatch: Dispatch) => {
    dispatch(
      setDenmarkTaxonomyCodeFetch({
        isLoading: true,
        error: "",
        data: { list: [] },
      })
    );
    const response = await fetchDenmarkTaxonomyByCodeApi(params);
    if (response.status === 200) {
      dispatch(
        setDenmarkTaxonomyCodeFetch({
          isLoading: false,
          error: response.error ?? "",
          data: { list: response.data ?? [] },
        })
      );
    } else {
      dispatch(
        setDenmarkTaxonomyCodeFetch({
          isLoading: false,
          error: response.error || "Failed to fetch taxonomy by code",
          data: { list: [] },
        })
      );
    }
  };

export const getSubtitleList =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await GetSubtitleListApi(params);

    if (response.status === 200) {
      dispatch(
        setSubtitleList({
          data: { list: response.data.list as Array<SubtitleModel> },
          error: response.error,
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setSubtitleList({
          data: { list: [] },
          error: response.error,
          isLoading: false,
        })
      );
    }
  };

export const getHomeList =
  (params: HomeListParams) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    // Set loading to true at the start
    const currentState = getState().media.homeList;
    dispatch(
      setHomeList({
        ...currentState,
        isLoading: true,
        error: "",
      })
    );

    const response = await HomeListApi(params);

    // Add a small delay to make loading state visible (remove in production)
    await new Promise((resolve) => setTimeout(resolve, 1000));
    dispatch(
      setHomeList({
        media_today_agg: response.data?.media_today_agg || {},
        media_yesterday_agg: response.data?.media_yesterday_agg || {},
        youtube_data_agg: response.data?.youtube_data_agg || {},
        video_analytics_agg: response.data?.video_analytics_agg || {},
        social_embeds_agg:
          response.data?.social_embeds_agg || ({} as SocialEmbedsAgg),
        error: response.error || "",
        isLoading: false,
      })
    );
  };

export const updateSubtitleList =
  (params: SubtitleModel) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await UpdateSubtitleApi(params);
    if (response.status === 200) {
      const currentList = getState().media.subtitleList.list || [];
      const updatedList = currentList.map((subtitle: SubtitleModel) =>
        subtitle.id === params.id
          ? {
              ...subtitle,
              enabled: params.enabled,
              status: response.data.status,
            }
          : subtitle
      );

      dispatch(
        setSubtitleList({
          data: { list: updatedList },
          error: response.error,
          isLoading: false,
        })
      );
    }
  };

export const getPresetList =
  (params?: PresetListModel) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setPresetList({ isLoading: true }));
    const response = await GetPresetListApi(params);

    if (response.status === 200) {
      dispatch(
        setPresetList({
          data: { list: response.data },
          error: response.error,
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setPresetList({
          data: { list: [] },
          error: response.error,
          isLoading: false,
        })
      );
    }
  };

export const getCurrentPresetDetails =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setCurrentPresetDetails({ isLoading: true }));
    const response = await GetCurrentPresetDetailsApi(params);
    dispatch(
      setCurrentPresetDetails({
        data: { list: response.data },
        error: response.error,
        isLoading: false,
      })
    );

    // Return the response data for direct usage
    return response;
  };

export const getDenmarkSectionList =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setDenmarkSectionList({ isLoading: true }));
    const response = await fetchDenmarkSectionListApi(params);
    if (response.status === 200) {
      dispatch(
        setDenmarkSectionList({
          data: { list: response.data },
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setDenmarkSectionList({ error: response.error, isLoading: false })
      );
    }
  };

export const getDenmarkEntityList =
  (params: { hostId: number | string; msId: number | string }) =>
  async (dispatch: Dispatch) => {
    dispatch(setDenmarkEntityList({ isLoading: true }));
    const response = await fetchDenmarkEntityGetApi(params);
    if (response.status === 200) {
      dispatch(
        setDenmarkEntityList({
          data: { list: response.data },
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setDenmarkEntityList({ error: response.error, isLoading: false })
      );
    }
    return response;
  };

const updateSectionChildrenByParentId = (
  list: SectionEntity[],
  parentId: number | string,
  children: SectionEntity[]
): SectionEntity[] =>
  list.map((node) => {
    if (String(node.msId) === String(parentId)) {
      return { ...node, childSections: children };
    }
    if (node.childSections?.length) {
      return {
        ...node,
        childSections: updateSectionChildrenByParentId(
          node.childSections,
          parentId,
          children
        ),
      };
    }
    return node;
  });

export const getDenmarkChildSectionList =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setDenmarkSectionList({ isLoading: true }));
    const response = await fetchDenmarkSectionListApi(params);
    if (response.status === 200) {
      const mediaState = getState().media;
      const currentList = mediaState?.denmarkSectionList?.list ?? [];
      const favoriteList = mediaState?.FavoriteDenmarkSectionList?.list ?? [];
      const entityList = mediaState?.denmarkEntityList?.list ?? [];
      const parentId = params?.parentId;
      const children = response?.data ?? [];
      const updatedList =
        parentId != null
          ? updateSectionChildrenByParentId(currentList, parentId, children)
          : currentList;
      const updatedFavoriteList =
        parentId != null
          ? updateSectionChildrenByParentId(favoriteList, parentId, children)
          : favoriteList;
      const updatedEntityList =
        parentId != null
          ? updateSectionChildrenByParentId(entityList, parentId, children)
          : entityList;
      dispatch(
        setDenmarkSectionList({
          data: { list: updatedList },
          isLoading: false,
        })
      );
      dispatch(
        setFavoriteDenmarkSectionList({
          data: { list: updatedFavoriteList },
        })
      );
      dispatch(
        setDenmarkEntityList({
          data: { list: updatedEntityList },
        })
      );
    } else {
      dispatch(
        setDenmarkSectionList({ error: response.error, isLoading: false })
      );
    }
  };

export const getAdminCurrentPresetDetails =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setAdminCurrentPresetDetails({ isLoading: true }));
    const response = await GetAdminCurrentPresetDetailsApi(params);
    dispatch(
      setAdminCurrentPresetDetails({
        data: { list: response.data },
        error: response.error,
        isLoading: false,
      })
    );
    return response;
  };

export const getArticleInfoList =
  (params: articleInfoParams) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setArticleInfoList({ isLoading: true }));
    const response = await GetArticleInfoListApi(params);
    if (response.status === 200) {
      dispatch(
        setArticleInfoList({ data: { list: response.data }, isLoading: false })
      );
    } else {
      dispatch(setArticleInfoList({ error: response.error, isLoading: false }));
    }
    return response;
  };

export const getAddedInList =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setAddedInList({ isLoading: true }));
    const response = await GetAddedInListApi(params);
    if (response.status === 200) {
      dispatch(
        setAddedInList({ data: { list: response.data }, isLoading: false })
      );
    } else {
      dispatch(setAddedInList({ error: response.error, isLoading: false }));
    }
    return response;
  };

let globalFavSectionSeq = 0;

export const getGlobalFavSectionList =
  (params: any) => async (dispatch: Dispatch) => {
    const seq = ++globalFavSectionSeq;
    dispatch(setGlobalFavSectionList({ isLoading: true }));
    const response = await GetFavoriteDenmarkSectionListApi(params);
    if (globalFavSectionSeq !== seq) return response;
    if (response.status === 200) {
      dispatch(
        setGlobalFavSectionList({
          data: { list: response.data },
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setGlobalFavSectionList({
          data: { list: [] },
          error: response.error || response.data?.errorMessage,
          isLoading: false,
        })
      );
    }
    return response;
  };

export const getFavoriteDenmarkSectionList =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setFavoriteDenmarkSectionList({ isLoading: true }));
    const response = await GetFavoriteDenmarkSectionListApi(params);
    if (response.status === 200) {
      dispatch(
        setFavoriteDenmarkSectionList({
          data: { list: response.data },
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setFavoriteDenmarkSectionList({
          error: response.error,
          isLoading: false,
        })
      );
    }
    return response;
  };

export const markFavorite = (params: any) => async (dispatch: Dispatch) => {
  dispatch(setGlobalFavSectionList({ isLoading: true }));
  const response = await MarkFavoriteApi(params);
  if (response.status === 200) {
    dispatch(
      setGlobalFavSectionList({
        data: { list: response.data },
        isLoading: false,
      })
    );
  } else {
    dispatch(
      setGlobalFavSectionList({
        error: response.error,
        isLoading: false,
      })
    );
  }
  return response;
};

export const removeFavorite = (params: any) => async (dispatch: Dispatch) => {
  dispatch(setGlobalFavSectionList({ isLoading: true }));
  const response = await RemoveFavoriteApi(params);
  if (response.status === 200) {
    dispatch(
      setGlobalFavSectionList({
        data: { list: response.data },
        isLoading: false,
      })
    );
  } else {
    dispatch(
      setGlobalFavSectionList({
        error: response.error,
        isLoading: false,
      })
    );
  }
  return response;
};

export const updatePreset =
  (params: PresetListModel) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await UpdatePresetApi(params);

    if (response.status === 200) {
      // Get the current preset list from the store
      const currentList = getState().media.presetList.list || [];

      // Find and update the preset with matching id
      const updatedList = currentList.map((preset) =>
        preset.id === params.id ? { ...preset, ...response.data } : preset
      );

      // Update the store with the new list
      dispatch(
        setPresetList({
          data: { list: updatedList },
          error: response.error,
          isLoading: false,
        })
      );
      return response;
    } else {
      toast.fail("");
      return response;
    }
  };

export const deletePreset =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await DeletePresetApi(params);
    if (response.status === 200) {
      const currentList = getState().media.presetList.list || [];
      const updatedList = currentList.filter(
        (preset) => preset.id !== params.id
      );
      dispatch(
        setPresetList({
          data: { list: updatedList },
          error: response.error,
          isLoading: false,
        })
      );
    } else {
      toast.fail("");
    }
  };

export const getUpdateMedia =
  (params: MediaFormData, isWizard = false) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setMediaDetails({ data: { isUpdating: true } }));
    const response = await UpdateMediaApi(params);

    // This is Callback function passed Previously
    if (response.status === 200) {
      if (!isWizard) {
        //
      }
      // Explicitly resolve with the successful response so callers can inspect it
      // and chain logic based on the returned value
    } else {
      toast.fail("");
      // Reject on non-200 so callers' catch blocks are executed
      // Preserve state update below regardless
      // Throw after dispatch below to ensure UI state resets correctly
    }

    dispatch(
      setMediaDetails({
        isLoading: false,
        error: response.error,
        data: {
          isUpdating: false,
          media: response.data,
        },
      })
    );
    if (response.status !== 200) {
      throw new Error(response.error || "Failed to update media");
    }
    return response;
  };

// ===== **** Chapter **** ===== //
export const getAddChapter =
  (params: any, cb: any) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setMediaChapters({ data: { isSavingChapter: true } }));
    const response = await GetAddChapterApi({
      // title: params.title,
      // description: params.description,
      // start_time: params.start_time,
      // end_time: params.end_time,
      // duration: params.duration,
      // thumb: params.thumb,
      // thumbId: params.thumbId,
      // base64: params.base64,
      // media: params.mediaId,
      // base: params.base,
      // generate: params.generate,
      // is_change: params.is_change,
      ...params,
      media: params.mediaId,
    });

    if (response.status && response.status === 200) {
      // Create a new chapter object with the server response data
      const newChapter = {
        ...response.data,
        thumb: params.thumbId || response.data.thumb,
        base: params.base || response.data.base,
        base64: params.base64,
        enable: params.enable,
        is_change: params.is_change,
        ct: Date.now(),
        mt: Date.now(),
      };

      // Update the store with the new chapter
      dispatch(addChapter(newChapter));

      cb && cb(response.data);
    } else {
      toast.fail("");
    }

    dispatch(
      setMediaChapters({
        error: response.error,
        data: { isSavingChapter: false },
      })
    );
  };

export const getDeleteChapter =
  (id: string) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setMediaChapters({ data: { isDeletingChapter: true } }));
    const response = await GetDeleteChapterApi(id);
    if (response.status && response.status === 200) {
      // !To Delete Chapter
      dispatch(deleteChapter(id));
    } else {
      toast.fail("");
    }
    dispatch(
      setMediaChapters({
        data: { isDeletingChapter: false },
        error: response.error,
      })
    );
  };

export const deleteDenmarkPublish =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await DeleteDenmarkPublishApi(params);
    if (response.status === 200) {
      toast.success("Denmark publish deleted successfully");
      // Remove the Denmark publish from the redux store's mediaDetails.media.socials
      const mediaDetails = getState().media.mediaDetails;
      if (
        mediaDetails &&
        mediaDetails.media &&
        Array.isArray(mediaDetails.media.socials)
      ) {
        const updatedSocials = mediaDetails.media.socials.filter(
          (item: any) => item.id !== params.id
        );
        const mediaId = String(mediaDetails.media?.id ?? "");
        if (mediaId) {
          dispatch(removePendingSocialUpdate({ mediaId, socialId: params.id }));
        }
        dispatch(
          setMediaDetails({
            ...mediaDetails,
            data: {
              ...(mediaDetails as any).data,
              media: {
                ...mediaDetails.media,
                socials: updatedSocials,
              },
            },
          })
        );
      }
    } else {
      toast.fail("Failed to delete Denmark publish");
    }
    return response;
  };

export const getListChapters =
  (id: string) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setMediaChapters({ isLoading: true }));
    const response = await GetListChaptersApi(id);
    dispatch(
      setMediaChapters({
        isLoading: false,
        error: response.error,
        data: {
          list: response.data,
          count: response.count,
          mediaId: response.mediaId,
        },
      })
    );
    const currentChapter = getState().media.mediaChapters.currentOpenedChapter;
    if (currentChapter) {
      const updatedChapter = response.data.find(
        (chapter) => chapter.id === currentChapter.id
      );
      if (updatedChapter) {
        dispatch(
          setCurrentOpenedChapter({
            ...currentChapter,
            ...updatedChapter,
            clip_start: updatedChapter.clip_start,
            clip_end: updatedChapter.clip_end,
          })
        );
      }
    }
  };

export const getCurrentChapter =
  (id: string) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await GetCurrentChapterApi(id);
    const updatedChapter = {
      ...response.data,
      clip_start: response.data.clip_start,
      clip_end: response.data.clip_end,
    };
    dispatch(setCurrentOpenedChapter(updatedChapter));
  };

export const getUpdateChapter =
  (chapter: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setMediaChapters({ data: { isSavingChapter: true } }));
    const response = await GetUpdateChapterApi({
      ...chapter,
      media: chapter.mediaId,
      // title: chapter.title,
      // description: chapter.description,
      // start_time: chapter.start_time,
      // end_time: chapter.end_time,
      // duration: chapter.duration,
      // base64: chapter.base64,
      // media: chapter.mediaId,
      // thumb: chapter.thumb,
      // id: chapter.id,
      // thumbId: chapter.thumbId,
      // generate: chapter.generate,
      // is_change: true,
      // base: chapter.base,
      // clip_id: chapter.clip_id,
    });
    //!Update the Chapter
    if (response.status === 200) {
      const updatedChapter = {
        ...response.data,
        clip_id: response.data.clip_id || chapter.clip_id,
        enable: response.data.enable || chapter.enable,
        clip_start: response.data.clip_start || chapter.clip_start,
        clip_end: response.data.clip_end || chapter.clip_end,
      };
      dispatch(
        updateChapter({
          result: updatedChapter,
          base: "",
          thumb: "",
          thumbBase64: chapter.base64,
        })
      );
    } else {
      toast.fail("");
    }
    dispatch(
      setMediaChapters({
        data: { isSavingChapter: false },
        error: response.error,
      })
    );
  };

// **** media publish ****
export const callPublishMedia =
  (
    params:
      | YoutubePublishPayload
      | FacebookPublishPayload
      | DenmarkPublishPayload
      | LinkedInPublishPayload,
    cb: (response: any) => void
  ) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      dispatch(setIsPublishingMedia(true));
      const response = await callPublishMediaApi(params);
      if (response && response.status === 200) {
        cb &&
          cb({
            status:
              response.data.upload_type === "lead"
                ? response.status
                : response.data.status,
            msg: response.data.msg,
            ct: response.data.ct,
          });
      } else {
        // Non-200: surface a failure status so the card/chip can show "failed" and stay actionable.
        toast.fail(
          response?.data?.msg || "Publishing failed. Please try again."
        );
        cb &&
          cb({ status: -1, msg: response?.data?.msg || "Publishing failed." });
      }
    } catch (error) {
      // Thrown/network error: flip the card to failed instead of leaving it silently stuck.
      toast.fail("Publishing failed. Please try again.");
      cb && cb({ status: -1, msg: "Publishing failed." });
    } finally {
      dispatch(setIsPublishingMedia(false));
    }
  };

export const updatePublishMedia =
  (
    params:
      | YoutubePublishPayload
      | FacebookPublishPayload
      | DenmarkPublishPayload
      | LinkedInPublishPayload,
    cb: (response: any) => void
  ) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      dispatch(setIsPublishingMedia(true));
      const response = await updatePublishMediaApi(params);
      if (response.status === 200) {
        // Check if response contains updated social data with id
        // The response might have the social object in different locations
        const responseData = response.data as any;

        // Try to find the social object in various possible locations
        let updatedSocial = null;

        // Case 1: response.data is the social object itself (has id and other social properties)
        if (responseData?.id) {
          updatedSocial = responseData;
        }
        // Case 2: response.data.social contains the social object
        else if (responseData?.social?.id) {
          updatedSocial = responseData.social;
        }
        // Case 3: response.data.result contains the social object
        else if (responseData?.result?.id) {
          updatedSocial = responseData.result;
        }
        // Case 4: response.data.result.social contains the social object
        else if (responseData?.result?.social?.id) {
          updatedSocial = responseData.result.social;
        }

        if (updatedSocial && updatedSocial.id) {
          dispatch(updateSocialInMediaDetails({ social: updatedSocial }));
        } else {
          console.warn(
            "updatePublishMedia: Could not find social object in response",
            response
          );
        }
      } else {
        toast.fail("");
      }
      cb && cb(response);
    } catch (_error) {
      toast.fail("");
    } finally {
      dispatch(setIsPublishingMedia(false));
    }
  };

export const updateVideoPublishMedia =
  (
    params:
      | YoutubePublishPayload
      | FacebookPublishPayload
      | DenmarkPublishPayload
      | LinkedInPublishPayload,
    cb: (response: any) => void
  ) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      dispatch(setIsPublishingMedia(true));
      const response = await updateVideoPublishMediaApi(params);
      if (response.status !== 200) {
        toast.fail("");
      }
      cb && cb(response);
    } catch (_error) {
      toast.fail("");
    } finally {
      dispatch(setIsPublishingMedia(false));
    }
  };

export const getVodDetails =
  (params: { video_id: string }, cb: (response: any) => void) => async () => {
    try {
      const response = await getVodDetailsApi(params);
      if (response.status !== 200) {
        toast.fail("");
      }
      cb && cb(response);
    } catch (_error) {
      toast.fail("");
    }
  };

// **** SECURITY *****
export const getUpdateMediaSecurity =
  (params: MediaFormData | MediaSecurityFormData) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(
      setMediaDetails({
        data: {
          isUpdating: true,
        },
      })
    );
    const response = await UpdateMediaApi(params);

    if (response.status === 200) {
      //
    } else {
      toast.fail("");
    }

    dispatch(
      setMediaDetails({
        error: response.error,
        data: {
          isUpdating: false,
          media: response.data,
        },
      })
    );
  };

export const fetchHosts =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setHostList({ isLoading: true }));
    try {
      const response = await fetchHostsApi(params);
      dispatch(
        setHostList({
          isLoading: false,
          list: response.data,
          error: response.error,
        })
      );
      if (response.status === 200) {
        if (response.data && response.data.length > 0) {
          dispatch(setIsRootLoading(false));
        } else {
          dispatch(setIsRootLoading(false));
        }
      } else {
        dispatch(setIsRootLoading(false));
      }
    } catch (error) {
      dispatch(
        setHostList({
          isLoading: false,
          list: [],
          error: "Failed to fetch hosts",
        })
      );
      dispatch(setIsRootLoading(false));
    }
  };

export const generateClip =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await generateClipApi(params);
    if (response.status === 200) {
      const openedChapter = getState().media.mediaChapters.currentOpenedChapter;
      const chapters = getState().media.mediaChapters.list;
      const targetChapter =
        chapters.find((chapter) => chapter.id === params?.id) || openedChapter;
      const updatedChapter = {
        ...targetChapter,
        clip_id: response.data.clip_id,
        enable: response.data.enable,
        clip_start: response.data.clip_start || targetChapter?.clip_start,
        clip_end: response.data.clip_end || targetChapter?.clip_end,
      };
      if (openedChapter?.id === targetChapter?.id) {
        dispatch(setCurrentOpenedChapter(updatedChapter));
      }
      const updatedChapters = chapters.map((chapter) =>
        chapter.id === targetChapter?.id
          ? { ...chapter, ...updatedChapter }
          : chapter
      );

      dispatch(
        setMediaChapters({
          data: {
            list: updatedChapters,
            count: updatedChapters.length,
            mediaId: getState().media.mediaDetails.media.id,
          },
        })
      );
    } else {
      toast.fail("");
    }
  };

export const trimMedia =
  (params: TrimMediaParams) =>
  async (
    dispatch: Dispatch,
    getState: () => RootState
  ): Promise<MediaModel | null> => {
    const response = await trimMediaApi(params);
    if (response.status === 200) {
      return response.data as MediaModel;
    } else {
      toast.fail("");
      return null;
    }
  };
export const fetchHostSection =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setHostSubsection({ isLoading: true }));
    const response = await fetchHostSubSectionAPI(params);
    if (response.error !== "") {
      toast.fail("");
    }
    dispatch(
      setHostSubsection({
        isLoading: false,
        list: response.data,
        error: response.error,
      })
    );
  };

export const fetchArticles =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await fetchArticlesApi(params);
    if (response.error !== "") {
      toast.fail("");
    }
    return response;
  };

export const searchArticles =
  (params: ArticleSearchParams) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setArticleSearchList({ isLoading: true }));
    const response = await articleSearchApi(params);
    if (response.error) {
      dispatch(
        setArticleSearchList({ error: response.error, isLoading: false })
      );
    } else {
      dispatch(
        setArticleSearchList({
          data: { list: response.data },
          isLoading: false,
          error: "",
        })
      );
    }
    return response;
  };

export const getLiveUrl =
  (params: { msid: string; hostid: string }) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setLiveUrl({ isLoading: true }));
    const response = await fetchLiveUrlApi(params);
    if (response.error) {
      dispatch(setLiveUrl({ error: response.error, isLoading: false }));
    } else {
      dispatch(
        setLiveUrl({
          data: { data: response.data },
          isLoading: false,
          error: "",
        })
      );
    }
    return response;
  };

export const getLivePreview =
  (params: { msid: string; hostid: string }) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setLivePreview({ isLoading: true }));
    const response = await fetchLivePreviewApi(params);
    if (response.error) {
      dispatch(setLivePreview({ error: response.error, isLoading: false }));
    } else {
      dispatch(
        setLivePreview({
          data: { data: response.data },
          isLoading: false,
          error: "",
        })
      );
    }
    return response;
  };

export const updateIsFilter =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setisFilter(params));
  };

export const updateActiveCustomUploadTab =
  (tab: string) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setActiveCustomUploadTab(tab));
  };

export const updateIsClearFilter =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setIsClearFilter(params));
  };
export const updateCurrentImage =
  (image: string | null) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setCurrentImage(image));
  };

export const updateCurrentImageId =
  (id: string | null) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setCurrentImageId(id));
  };

export const createCategory =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await createCategoryApi(params);

    if (response.error === "") {
      let subCategoryList = response.data?.sub_meta;
      subCategoryList = subCategoryList?.map((item: any) => {
        return item.name;
      });

      dispatch(
        setCategories({
          ...getState().app.categories,
          [response.data.name]: subCategoryList,
        })
      );
      if (params.type === "category") {
        dispatch(
          setCategory([response?.data, ...(getState()?.app?.category || [])])
        );
        // Also update the constants state for display
        const currentBunchCategoryList =
          getState().constants.bunchCategoryList.list || [];
        dispatch(
          setBunchCategoryList({
            data: {
              list: [response?.data, ...currentBunchCategoryList],
              count: currentBunchCategoryList.length + 1,
              isLoading: false,
              error: "",
            },
          })
        );
      } else if (params.type === "language") {
        dispatch(
          setLanguage([response?.data, ...(getState()?.app?.language || [])])
        );
        // Also update the constants state for display
        const currentBunchLanguageList =
          getState().constants.bunchLanguageList.list || [];
        dispatch(
          setBunchLanguageList({
            data: {
              list: [response?.data, ...currentBunchLanguageList],
              count: currentBunchLanguageList.length + 1,
              isLoading: false,
              error: "",
            },
          })
        );
      } else if (params.type === "tag") {
        dispatch(setTag([response?.data, ...(getState()?.app?.tag || [])]));
      } else if (params.type === "cast") {
        dispatch(setCast([response?.data, ...(getState()?.app?.cast || [])]));
      } else if (params.type === "genre") {
        dispatch(setGenre([response?.data, ...(getState()?.app?.genre || [])]));
      }
    } else {
      toast.fail("");
    }
  };

export const getCategoryList =
  () => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setCategoryList({ isLoading: true }));
    const response = await getCategoryListApi();
    if (response.status === 200) {
      dispatch(
        setCategoryList({
          isLoading: false,
          list: response.data,
          error: response.error,
        })
      );
    } else {
      toast.fail("");
    }
  };

export const updateCategory =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await updateCategoryApi(params);

    if (response.status === 200 && response.error === "") {
      // Get the current category list from the store
      if (params.type === "category") {
        const currentList = getState().app.category || [];

        // Update only the category with the matching id, and only the fields present in response.data
        const updatedList = currentList.map((category: any) =>
          category.id === params.id
            ? { ...category, ...response.data }
            : category
        );
        dispatch(setCategory(updatedList));

        // Also update the constants state for display
        const currentBunchCategoryList =
          getState().constants.bunchCategoryList.list || [];
        const updatedBunchList = currentBunchCategoryList.map(
          (category: any) =>
            category.id === params.id
              ? { ...category, ...response.data }
              : category
        );
        dispatch(
          setBunchCategoryList({
            data: {
              list: updatedBunchList,
              count: updatedBunchList.length,
              isLoading: false,
              error: "",
            },
          })
        );
      } else if (params.type === "language") {
        const currentList = getState().app.language || [];
        const updatedList = currentList.map((language: any) =>
          language.id === params.id
            ? { ...language, ...response.data }
            : language
        );

        dispatch(setLanguage(updatedList));

        // Also update the constants state for display
        const currentBunchLanguageList =
          getState().constants.bunchLanguageList.list || [];
        const updatedBunchList = currentBunchLanguageList.map(
          (language: any) =>
            language.id === params.id
              ? { ...language, ...response.data }
              : language
        );
        dispatch(
          setBunchLanguageList({
            data: {
              list: updatedBunchList,
              count: updatedBunchList.length,
              isLoading: false,
              error: "",
            },
          })
        );
      } else if (params.type === "tag") {
        const currentList = getState().app.tag || [];
        const updatedList = currentList.map((tag: any) =>
          tag.id === params.id ? { ...tag, ...response.data } : tag
        );

        dispatch(setTag(updatedList));
      } else if (params.type === "cast") {
        const currentList = getState().app.cast || [];
        const updatedList = currentList.map((cast: any) =>
          cast.id === params.id ? { ...cast, ...response.data } : cast
        );
        dispatch(setCast(updatedList));
      } else if (params.type === "genre") {
        const currentList = getState().app.genre || [];
        const updatedList = currentList.map((genre: any) =>
          genre.id === params.id ? { ...genre, ...response.data } : genre
        );
        dispatch(setGenre(updatedList));
      } else {
        toast.fail("");
      }
    } else {
      toast.fail("");
    }
  };

export const deleteCategory =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await deleteCategoryApi(params);

    if (response.status === 200 && response.error === "") {
      if (params.type === "category") {
        dispatch(
          setCategory(
            getState().app.category.filter(
              (item: any) => item.id !== params.item.id
            )
          )
        );
        // Also update the constants state for display
        const currentBunchCategoryList =
          getState().constants.bunchCategoryList.list || [];
        const updatedList = currentBunchCategoryList.filter(
          (item: any) => item.id !== params.item.id
        );
        dispatch(
          setBunchCategoryList({
            data: {
              list: updatedList,
              count: updatedList.length,
              isLoading: false,
              error: "",
            },
          })
        );
      } else if (params.type === "language") {
        dispatch(
          setLanguage(
            getState().app.language.filter(
              (item: any) => item.id !== params.item.id
            )
          )
        );
        // Also update the constants state for display
        const currentBunchLanguageList =
          getState().constants.bunchLanguageList.list || [];
        const updatedList = currentBunchLanguageList.filter(
          (item: any) => item.id !== params.item.id
        );
        dispatch(
          setBunchLanguageList({
            data: {
              list: updatedList,
              count: updatedList.length,
              isLoading: false,
              error: "",
            },
          })
        );
      } else if (params.type === "tag") {
        dispatch(
          setTag(
            getState().app.tag.filter((item: any) => item.id !== params.item.id)
          )
        );
      } else if (params.type === "cast") {
        dispatch(
          setCast(
            getState().app.cast.filter(
              (item: any) => item.id !== params.item.id
            )
          )
        );
      } else if (params.type === "genre") {
        dispatch(
          setGenre(
            getState().app.genre.filter(
              (item: any) => item.id !== params.item.id
            )
          )
        );
      }
    } else {
      toast.fail("");
    }
  };

// export const updateTempThumbnailImage =
//   (image: string | null) => async (dispatch: Dispatch, getState: () => RootState) => {
//     dispatch(setTempThumbnailImage(image));
//   };

// export const updateTempThumbnailImageId =
//   (id: string | null) => async (dispatch: Dispatch, getState: () => RootState) => {
//     dispatch(setTempThumbnailImageId(id));
//   };

export const updateIsThumbnailUploading =
  (isUploading: boolean) => (dispatch: Dispatch) => {
    dispatch(setIsThumbnailUploading(isUploading));
  };

export const updatePreviousFilters = (filters: any) => (dispatch: Dispatch) => {
  dispatch(setPreviousFilters(filters));
};

export const fetchPriorityList =
  (params: FetchPriorityListParams) => async (dispatch: Dispatch) => {
    dispatch(setPriorityList({ isLoading: true }));
    const response = await fetchPriorityListApi(params);
    if (response.status === 200) {
      dispatch(
        setPriorityList({
          data: { list: response.data },
          isLoading: false,
        })
      );
    } else {
      dispatch(setPriorityList({ error: response.error, isLoading: false }));
    }
    return response;
  };

export const updatePriorityList =
  (params: UpdatePriorityListReq & { sectionId?: number }) =>
  async (dispatch: Dispatch) => {
    dispatch(setPriorityList({ isLoading: true }));
    const response = await updatePriorityListApi(params);
    if (response.status === 200 && !response.error) {
      dispatch(
        setPriorityList({
          data: { list: response.data },
          isLoading: false,
        })
      );
      // Sync server-returned entity back into prioritySectionsList
      if (params.sectionId != null && response.data?.priorityListEntity) {
        dispatch(
          syncSavedSectionPriorityList({
            sectionId: params.sectionId,
            priorityListEntity: response.data.priorityListEntity,
          })
        );
      }
    } else {
      dispatch(setPriorityList({ error: response.error, isLoading: false }));
    }
    // Return response so callers can track per-row save status
    return response;
  };

export const getKeywords =
  (hostId: number, text: string) => async (dispatch: Dispatch) => {
    dispatch(setKeywordList({ isLoading: true }));
    const response = await GetKeywordsApi(hostId, text);
    if (response.status === 200) {
      dispatch(
        setKeywordList({
          isLoading: false,
          error: response.error,
          data: { list: response.data },
        })
      );
    } else {
      dispatch(setKeywordList({ error: response.error, isLoading: false }));
    }
    return response;
  };

export const getCategoryTags =
  (host: number, query: string) => async (dispatch: Dispatch) => {
    dispatch(setCategoryTagsResult({ isLoading: true }));
    const response = await GetCategoryTagsApi(host, query);
    if (response.status === 200) {
      dispatch(
        setCategoryTagsResult({
          isLoading: false,
          error: response.error,
          data: response.data,
        })
      );
    } else {
      dispatch(
        setCategoryTagsResult({ error: response.error, isLoading: false })
      );
    }
    return response;
  };

export const getAiVoices =
  (params?: { key?: string }) => async (dispatch: Dispatch) => {
    dispatch(setAiVoices({ isLoading: true }));
    const response = await GetAiVoicesApi(params);
    if (response.status === 200) {
      dispatch(
        setAiVoices({
          isLoading: false,
          error: response.error,
          data: { voices: response.data },
        })
      );
    } else {
      dispatch(setAiVoices({ error: response.error, isLoading: false }));
    }
    return response;
  };

export const getAiLanguages =
  (params?: { key?: string }) => async (dispatch: Dispatch) => {
    dispatch(setAiLanguages({ isLoading: true }));
    const response = await GetAiLanguagesApi(params);
    if (response.status === 200) {
      dispatch(
        setAiLanguages({
          isLoading: false,
          error: response.error,
          data: { languages: response.data },
        })
      );
    } else {
      dispatch(setAiLanguages({ error: response.error, isLoading: false }));
    }
    return response;
  };

export const generateTextToAudio =
  (params: TextToAudioParams) => async (dispatch: Dispatch) => {
    dispatch(setAiTextToAudio({ isLoading: true }));
    const response = await TextToAudioApi(params);
    if (response.status === 200) {
      dispatch(
        setAiTextToAudio({
          isLoading: false,
          error: response.error,
          data: { result: response.data },
        })
      );
    } else {
      dispatch(setAiTextToAudio({ error: response.error, isLoading: false }));
    }
    return response;
  };

export const generateTextToDialogue =
  (params: TextToDialogueParams) => async (dispatch: Dispatch) => {
    dispatch(setAiTextToDialogue({ isLoading: true }));
    const response = await TextToDialogueApi(params);
    if (response.status === 200) {
      dispatch(
        setAiTextToDialogue({
          isLoading: false,
          error: response.error,
          data: { result: response.data },
        })
      );
    } else {
      dispatch(
        setAiTextToDialogue({ error: response.error, isLoading: false })
      );
    }
    return response;
  };
